import { getTranscript } from '@ax/service';
import { useQuery } from '@tanstack/react-query';

export function useGetTranscriptApi(noteId: string, transcriptId: string) {
  return useQuery({
    queryKey: ['transcriptList', noteId, transcriptId],
    queryFn: () => getTranscript({ noteId, transcriptId }),
    onError: (error: Error) => {
      console.log(error.message);
    },
    enabled: !!noteId && !!transcriptId,
    retry: 10,
    retryDelay: 2000,
    cacheTime: 2000,
  });
}
